module.exports = __webpack_public_path__ + "img/nl.2a3ac22b.svg";